import { render } from "./TriggersTabletFormComponentDetails.vue?vue&type=template&id=43270fa0"
import script from "./TriggersTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./TriggersTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__